import imageCompression from 'browser-image-compression'

export const imageToBlob = (file: File) => {
  return new Promise<string | undefined>((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener('error', event => {
      event.preventDefault()
      reject(new Error('failed'))
    })
    reader.addEventListener('load', () => {
      resolve(reader.result?.toString())
    })
    reader.readAsDataURL(file)
  })
}

export const validateAndCompressImageFile = async (image: File) => {
  const orientation = await imageCompression.getExifOrientation(image)
  const file = await imageCompression(image, {
    useWebWorker: true,
    exifOrientation: orientation > 0 ? orientation : 1,
  })
  return { file, orientation }
}
